// extracted by mini-css-extract-plugin
module.exports = {"md-container":"my-markdown_md-container__vpMsl"};